import { CountUp } from 'countup.js';
import { handleDefaultModal } from '../../../../utils';
import locale from '../../../../translations/ru.json';

document.addEventListener('DOMContentLoaded', function () {
  const tooltipElement = document.querySelector('.tooltip');

  function formatNumberWithSpaces(number) {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  }

  function handleInput(event) {
    let value = event.target.value.replace(/\s+/g, ''); // Удаляем все пробелы
    if (!isNaN(value) && value !== '') {
      event.target.value = formatNumberWithSpaces(value);
    }
  }

  const inputs = document.querySelectorAll(
    'input[name="NE"], input[name="ES"], input[name="HC"], input[name="RR"], input[name="OH"], input[name="HR"]',
  );

  function animateValue(elementSelector, start, end, duration) {
    const element = document.querySelector(elementSelector);
    const countUp = new CountUp(element, end, {
      startVal: start,
      duration: duration,
      useEasing: true,
      useGrouping: true,
      separator: ' ',
      decimal: ',',
    });

    if (!countUp.error) {
      countUp.start();
    } else {
      console.error(countUp.error);
    }
  }

  function isNumber(value) {
    const regex = /^[0-9]+$/;
    return regex.test(value);
  }

  function getNumericValue(selector) {
    const value = document.querySelector(selector).value.replace(/\s+/g, '');
    return isNumber(value) ? parseFloat(value) : NaN;
  }

  function setErrorClass(element, condition) {
    if (condition) {
      element.parentElement.classList.add('error');
    } else {
      element.parentElement.classList.remove('error');
    }
  }

  function addErrorClassIfNeeded() {
    let hasError = false;

    inputs.forEach((input) => {
      const value = input.value.replace(/\s+/g, '');
      const isValid = isNumber(value);
      setErrorClass(input, !isValid);
      if (!isValid) hasError = true;
    });

    return hasError;
  }

  function validateCurrentInput(event) {
    const input = event.target;
    const value = input.value.replace(/\s+/g, '');
    setErrorClass(input, !isNumber(value));
  }

  function calculateValues() {
    // const mobileBottomBlockValue = document.querySelector('.total_mobile_value .amount');

    const NE = getNumericValue('input[name="NE"]');
    const ES = getNumericValue('input[name="ES"]');
    const HC = getNumericValue('input[name="HC"]');
    const RR = getNumericValue('input[name="RR"]');
    const OH = getNumericValue('input[name="OH"]');
    const HR = getNumericValue('input[name="HR"]');

    let A = Math.ceil(((HC * RR * NE) / 100) * 0.2);
    let B = Math.ceil(OH * HR * NE * 0.33);
    let C = Math.ceil(ES * NE);
    let total = Math.ceil(A + B + C);

    if ([NE, ES, HC, RR, OH, HR].some((value) => isNaN(value))) {
      A = 0;
      B = 0;
      C = 0;
      total = 0;
      tooltipElement.style.display = 'flex';
      animateValue('.amount_a', parseFloat(document.querySelector('.amount_a').textContent.replace(/\s/g, '')), A, 2);
      animateValue('.amount_b', parseFloat(document.querySelector('.amount_b').textContent.replace(/\s/g, '')), B, 2);
      animateValue('.amount_c', parseFloat(document.querySelector('.amount_c').textContent.replace(/\s/g, '')), C, 2);
      document.querySelectorAll('.total_value .amount').forEach((element) => {
        animateValue(`#${element.id}`, parseFloat(element.innerText.replace(/\s/g, '')), total, 2);
      });
      // mobileBottomBlockValue.innerText = formatNumberWithSpaces(total);
      return;
    }

    tooltipElement.style.display = 'none';

    animateValue('.amount_a', parseFloat(document.querySelector('.amount_a').textContent.replace(/\s/g, '')), A, 2);
    animateValue('.amount_b', parseFloat(document.querySelector('.amount_b').textContent.replace(/\s/g, '')), B, 2);
    animateValue('.amount_c', parseFloat(document.querySelector('.amount_c').textContent.replace(/\s/g, '')), C, 2);
    document.querySelectorAll('.total_value .amount').forEach((element) => {
      animateValue(`#${element.id}`, parseFloat(element.innerText.replace(/\s/g, '')), total, 2);
    });
    // mobileBottomBlockValue.innerText = formatNumberWithSpaces(total);

    updateTextareaPlaceholder(NE, total);
  }

  function updateTextareaPlaceholder(NE, total) {
    const textarea = document.querySelector('.textarea_roi textarea');
    textarea.innerText = `Рассчитать стоимость внедрения решения. Количество новых сотрудников — ${formatNumberWithSpaces(
      NE,
    )} чел. Расчетная выгода от внедрения — ${formatNumberWithSpaces(total)} руб.`;
  }

  inputs.forEach((input) => {
    input.addEventListener('input', handleInput);
    input.addEventListener('blur', (event) => {
      validateCurrentInput(event);
      calculateValues();
    });
  });

  const modalSelector = '#form-modal';
  const formSelector = '#demonstration-form-modal';

  const modal = document.querySelector(modalSelector);
  const header = modal ? modal.querySelector('[data-modal-header]') : null;
  const text = modal ? modal.querySelector('[data-modal-text]') : null;
  const buttonText = modal ? modal.querySelector('[data-modal-button]') : null;
  const modalHeaderInput = modal ? modal.querySelector('input[name=modal-header]') : null;
  const modalTypeInput = modal ? modal.querySelector('input[name=modal-type]') : null;

  const demonstrationForm = document.querySelector(formSelector);
  const nameField = demonstrationForm ? demonstrationForm.querySelector('[name=name]') : null;
  const emailField = demonstrationForm ? demonstrationForm.querySelector('[name=email]') : null;
  const phoneField = demonstrationForm ? demonstrationForm.querySelector('[name=phone]') : null;
  const messageField = demonstrationForm ? demonstrationForm.querySelector('[name=message]') : null;

  const content = {
    get_calc_roi: {
      header: locale['formsModal.getCalcRoi.header'],
      text: locale['formsModal.getCalcRoi.text'],
      button: locale['formsModal.getCalcRoi.button'],
    },
  };

  const onClickShowModal = (e) => {
    const hasError = addErrorClassIfNeeded();
    if (hasError) {
      tooltipElement.style.display = 'flex';
      return;
    }

    tooltipElement.style.display = 'none';
    resetForm();
    changeContent(content[e.currentTarget.dataset.modalForm], e.currentTarget.dataset.modalForm);

    handleDefaultModal(modalSelector, () => {
      resetForm();
    });
  };

  const changeContent = (contentItem, contentItemKey) => {
    if (header) {
      header.innerHTML = contentItem.header;
    }
    if (text) {
      text.innerHTML = contentItem.text;
    }
    if (buttonText) {
      buttonText.innerHTML = contentItem.button;
    }
    if (modalHeaderInput) {
      modalHeaderInput.value = contentItem.header;
    }
    if (modalTypeInput) {
      modalTypeInput.value = contentItemKey;
    }
  };

  const resetForm = () => {
    if (demonstrationForm) {
      demonstrationForm.classList.remove('success');
      demonstrationForm.reset();
    }
    if (nameField) {
      nameField.parentElement.classList.remove('error');
      nameField.disabled = false;
    }
    if (emailField) {
      emailField.parentElement.classList.remove('error');
      emailField.disabled = false;
    }
    if (phoneField) {
      phoneField.parentElement.classList.remove('error');
      phoneField.disabled = false;
    }
    if (messageField) {
      messageField.disabled = false;
    }
  };

  const modalButton = document.querySelector('[data-modal-form="get_calc_roi"]');

  if (modalButton) {
    modalButton.addEventListener('click', onClickShowModal);
  }
});
